<template>
  <div class="cooperationBox">
    <div class="nav">
      <ul>
        <li
          v-for="(item, index) in navList"
          :key="index"
          :class="navIndex == index ? 'active' : ''"
          @click="switchNav(index)"
        >
          <span>{{ item.name }}</span>
        </li>
      </ul>
    </div>
    <div class="main">
      <div class="swiper-container">
        <swiper ref="mySwiper" :options="swiperOption" class="swiper-wrapper">
          <swiper-slide>
            <div class="content">
              <div class="common">
                <div class="commonTitle">
                  <h5>可合作的内容</h5>
                </div>
                <div class="commonContent">
                  <ul>
                    <li><i>·</i><span>机构、企业商务、课程团购合作</span></li>
                    <li><i>·</i><span>艺术家、老师、学校、大师班合作</span></li>
                    <li><i>·</i><span>音乐会、文化馆、政府机构合作</span></li>
                    <li><i>·</i><span>数字文化资源采购合作</span></li>
                    <li><i>·</i><span>市场合作（媒体、公关）</span></li>
                  </ul>
                </div>
              </div>
              <div class="common">
                <div class="commonTitle">
                  <h5>联系方式</h5>
                </div>
                <div class="commonContent">
                  <ul>
                    <li><i>·</i><span>手机号码:18668076196（邓女士) </span></li>
                    <li><i style="opacity:0">·</i><span ><em style="opacity:0"> 手机号码:</em>18658135757（汪先生） </span></li>
                    <li><i>·</i><span>邮箱：dengsuling@iartschool.com</span> </li>
                    <li><i style="opacity:0">·</i><span ><em style="opacity:0">邮箱：</em>wangkun@iartschool.com</span></li>
                  </ul>
                </div>
              </div>
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="partner">
              <div class="common">
                <div class="commonTitle">
                  <h5>如何成为合作人？</h5>
                </div>
                <div class="commonContent">
                  <ul>
                    <li>
                      <i>·</i
                      ><span
                        >有良好的会员卡充值/运营商/艺术类渠道代理运营及
                        拓展经验</span
                      >
                    </li>
                    <li>
                      <i>·</i
                      ><span>具备专业的技术、营销、运营及售后等服务团队</span>
                    </li>
                    <li><i>·</i><span>良好的企业信誉及行业美誉度</span></li>
                    <li>
                      <i>·</i
                      ><span>在预授权的分销行业内，有丰富的渠道资源</span>
                    </li>
                    <li>
                      <i>·</i
                      ><span
                        >认同并接受爱艺术+关于合同付款、合作伙伴资格等各项要求</span
                      >
                    </li>
                  </ul>
                </div>
              </div>
              <div class="common">
                <div class="commonTitle">
                  <h5>合伙人有哪些收益？</h5>
                </div>
                <div class="commonContent">
                  <ul>
                    <li>
                      <i></i
                      ><span>
                        根据代理直接销售在线课程的总费用，计算其销售额，以分档比例计提在线课程推广费。</span
                      >
                    </li>
                  </ul>
                </div>
              </div>
              <div class="common">
                <div class="commonTitle">
                  <h5>联系方式</h5>
                </div>
                <div class="commonContent">
                  <ul>
                    <li><i>·</i><span>手机号码: 4009-260-658&nbsp;&nbsp;(洪小姐)</span></li>
                    <li><i>·</i><span>邮箱：partner@iartschool.com</span></li>
                  </ul>
                </div>
              </div>
            </div>
          </swiper-slide>
        </swiper>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "cooperation",
  metaInfo() {
    return {
      title: "商务合作",
    };
  },
  data() {
    return {
      navList: [{ name: "内容合作" }, { name: "招募合伙人" }],
      navIndex: 0,
      swiperOption: {
        autoHeight: true,
        onSlideChangeStart: function (swiper) {
          this.navIndex = swiper.activeIndex;
        }.bind(this),
      },
    };
  },
  components: {},
  mounted() {
  },
  methods: {
    switchNav(index) {
      this.navIndex = index;
      this.$refs.mySwiper.swiper.slideTo(index, 200, false);
    },
  },
};
</script>

<style lang="scss" scoped>
.cooperationBox {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  .nav {
    background: #ffffff;
    padding: 9px 16px;
    ul {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-around;
      li {
        padding: 9px 0;
        span {
          font-size: 16px;
          line-height: 22px;
          color: #999999;
        }
      }
      li.active {
        position: relative;
        span {
          color: #333333;
          font-weight: 600;
        }
      }
      li.active::before {
        content: " ";
        display: inline-block;
        width: 18px;
        height: 2px;
        background: #35363c;
        position: absolute;
        left: 50%;
        margin-left: -8px;
        bottom: 0;
      }
    }
  }
  .main {
    flex: 1;
    overflow: auto;
    background: #f5f6f7;
    padding: 11px 16px;
    .common {
      height: 100%;
      padding: 24px 16px;
      background: #ffffff;
      .commonTitle {
        border-bottom: 1px solid rgba(151, 151, 151, 0.2);
        padding-bottom: 16px;
        h5 {
          font-size: 16px;
          line-height: 22px;
          color: #333333;
          font-weight: 600;
        }
      }
      .commonContent {
        padding-top: 16px;
        li {
          display: flex;
          flex-direction: row;
          align-items: flex-start;
          i,
          span {
            font-size: 14px;
            line-height: 24px;
            color: #35363c;
          }
          i {
            margin-right: 4px;
          }
          span {
            flex: 1;
            // font-weight: 400;
          }
        }
      }
    }
    .common:not(:last-child) {
      margin-bottom: 24px;
    }
  }
}
</style>